module.exports = __webpack_public_path__ + "static/media/17.305665e5.gif";